export default __webpack_public_path__ + "static/media/ico_clinic_gray.baa88787.svg";